// src/pages/common-components/shared/BlogImage.tsx
// Shared blog-post image: shows the blog placeholder graphic until the real
// image finishes loading (or indefinitely, if it never does — better than a
// broken-image icon). Used by both the blog list (Blog.tsx) and the blog
// detail page (BlogView.tsx) so the two stay consistent.
import React, { useState } from 'react';

interface BlogImageProps {
  src: string;
  alt: string;
}

const PLACEHOLDER = 'asset/images/blog-placeholder.png';

const BlogImage: React.FC<BlogImageProps> = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="blog-image-wrapper">
      {!loaded && (
        <img src={PLACEHOLDER} alt="placeholder" className="blog-image" />
      )}
      <img
        src={src}
        alt={alt}
        className="blog-image"
        style={{ display: loaded ? 'block' : 'none' }}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default BlogImage;
